import { useRouter } from "next/router";
import { useEffect } from "react";
import { createGlobalState } from "react-hooks-global-state";

const { useGlobalState } = createGlobalState({
  referral: undefined as string | undefined,
});

export default function useIDOReferral() {
  const router = useRouter();
  const referral = router.query.des as string | undefined;

  const [referralState, setReferralState] = useGlobalState("referral");

  useEffect(() => {
    if (referralState) {
      router.replace({
        query: {
          des: referralState,
        },
      });
    }
  }, [referralState]);

  useEffect(() => {
    setReferralState(referral);
  }, [referral]);

  return {
    referral,
  };
}
